export enum ApproveType {
    approveDocument = 'APPROVE_DOCUMENT'
}

export const approveTypes = Object.values(ApproveType) as string[]
